/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetYoutubeIntegrationStatsSelfViewersQueryResponse, GetYoutubeIntegrationStatsSelfViewersPathParams, GetYoutubeIntegrationStatsSelfViewersQueryParams } from "../models/GetYoutubeIntegrationStatsSelfViewers";

export function getGetYoutubeIntegrationStatsSelfViewersUrl(station: GetYoutubeIntegrationStatsSelfViewersPathParams["station"]) {
  const res = { method: 'GET', url: `/youtube-stats/viewers/${station}/self` as const }
  return res
}

/**
 * @description Uses the station `youtubeChannelId`. Responds with 400 when it is not set, and 404 when the channel is not in the live-viewers catalog.
 * @summary Viewer time series for the station YouTube channel
 * {@link /youtube-stats/viewers/:station/self}
 */
export async function getYoutubeIntegrationStatsSelfViewers(station: GetYoutubeIntegrationStatsSelfViewersPathParams["station"], params: GetYoutubeIntegrationStatsSelfViewersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetYoutubeIntegrationStatsSelfViewersQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetYoutubeIntegrationStatsSelfViewersUrl(station).url.toString(), params, ... requestConfig })
  return res.data
}